<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>体力事件配置</span>

          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload ref="upload" class="upload-demo" :action="sys_app_logoAction" accept="xlsx" :limit="1" :on-success="(res)=>{return importUploadSuccess(res)}" :headers="headers">
                <el-button v-permisaction="['config:dice:import']" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button v-permisaction="['config:dice:export']" type="primary" icon="el-icon-download" size="mini" @click="exportData()">导出</el-button>
            </el-col>
            <el-col :span="1.5">
              <clear-cache-apply />
              <sync-data />
            </el-col>
          </el-row>
        </div>
        <el-table :data="formData" border stripe>
          <el-table-column prop="level" label="等级" width="150">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.level" />
            </template>
          </el-table-column>
          <el-table-column prop="num" label="次数" width="150">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.num" />
            </template>
          </el-table-column>
          <el-table-column prop="lose" label="扣钱" width="250">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.lose" />
            </template>
          </el-table-column>
          <el-table-column prop="v" label="体力权重" width="200">
            <template slot-scope="scope">
              <el-input v-model.number="scope.row.v" />
            </template>
          </el-table-column>
          <el-table-column prop="base">
            <template slot-scope="scope">
              <div v-html="handlerShow(scope.row.config2)" />
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" icon="el-icon-edit" @click="visibleArr[scope.$index].visible = true"> 体力配置</el-button>
              <el-drawer title="体力配置" :before-close="(d)=>{return handleClose(d, scope.$index)}" size="60%" :visible="visibleArr[scope.$index].visible">
                <el-table :data="scope.row.config2" border stripe>
                  <el-table-column prop="level" label="倍率(min)">
                    <template slot-scope="scope2">
                      <el-input v-model.number="scope2.row.minBet" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="num" label="倍率(max)">
                    <template slot-scope="scope2">
                      <el-input v-model.number="scope2.row.maxBet" />
                    </template>
                  </el-table-column>
                  <el-table-column prop="num" label="概率(%)">
                    <template slot-scope="scope2">
                      <el-input v-model.number="scope2.row.pro" />
                    </template>
                  </el-table-column>
                  <el-table-column v-for="(item, index) in spinsNum" :key="index" prop="base" :label="'体力'+item+'点'">
                    <template slot-scope="scope2">
                      <el-input v-model.number="scope2.row.weight[index].v" />
                    </template>
                  </el-table-column>
                </el-table>
                <el-button size="small" style="margin-top: 1rem" type="primary" @click="addWeight(scope.row.config2)">【+】</el-button>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="visibleArr[scope.$index].visible = false">取 消</el-button>
                  <el-button type="primary" @click="visibleArr[scope.$index].visible = false">确 定</el-button>
                </div>
              </el-drawer>
              <el-button v-permisaction="['config:dice:del']" style="margin-left: 5px" size="mini" type="danger" @click="del(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button v-permisaction="['config:dice:add']" style="margin-top: 10px" type="primary" @click="add()">+</el-button>
        <el-button v-permisaction="['config:dice:add']" style="margin-top: 10px" type="primary" @click="onSubmit()">保存</el-button>
        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables()"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { deleteDiceCfg, exportDiceCfg, getDiceCfg, importDiceCfg, updateDiceCfg } from '@/api/config/slot'
import { getToken } from '@/utils/auth'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'DiceConfig',
  components: { SyncData, ClearCacheApply },
  data() {
    return {
      spinsNum: [1, 2, 3, 4, 5, 6],
      loading: false,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      total: 0,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      visibleArr: [
        { 'visible': false }
      ],
      formData: [{
        'level': 0,
        'num': 0,
        'v': 0,
        'lose': 0,
        'config': [
          { 'id': 1, 'v': 1 },
          { 'id': 2, 'v': 1 },
          { 'id': 3, 'v': 1 },
          { 'id': 4, 'v': 1 },
          { 'id': 5, 'v': 1 },
          { 'id': 6, 'v': 1 }
        ],
        'config2': [
          { 'minBet': 1, 'maxBet': 2, 'pro': 1, 'weight': [{ 'v': 10, 'id': 1 }, { 'v': 10, 'id': 2 }, { 'v': 20, 'id': 3 }, { 'v': 30, 'id': 4 }, { 'v': 20, 'id': 5 }, { 'v': 10, 'id': 6 }] }
        ],
        'base': 0
      }]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    handleClose(d, index) {
      this.visibleArr[index].visible = false
    },
    onSubmit(name) {
      const data = JSON.stringify(this.formData)
      updateDiceCfg({ data: data, name: name }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getDiceCfg(this.queryParams).then(res => {
        if (res.code === 200) {
          res.data.list.forEach((item) => {
            this.visibleArr.push({ 'visible': false })
          })
          this.formData = res.data.list
          this.total = res.data.count
        } else {
          this.msgError(res.msg)
        }
      })
    },
    add() {
      this.formData.push({
        'level': 0,
        'num': 0,
        'v': 0,
        'lose': 0,
        'config': [
          { 'id': 1, 'v': 1 },
          { 'id': 2, 'v': 1 },
          { 'id': 3, 'v': 1 },
          { 'id': 4, 'v': 1 },
          { 'id': 5, 'v': 1 },
          { 'id': 6, 'v': 1 }
        ],
        'config2': [
          { 'minBet': 1, 'maxBet': 2, 'pro': 2, 'weight': [{ 'v': 10, 'id': 1 }, { 'v': 10, 'id': 2 }, { 'v': 20, 'id': 3 }, { 'v': 30, 'id': 4 }, { 'v': 20, 'id': 5 }, { 'v': 10, 'id': 6 }] }
        ],
        'base': 0
      })
      this.visibleArr.push({ 'visible': false })
    },
    del(id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteDiceCfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    importUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importDiceCfg({ path: response.data.path }).then(res => {
        // eslint-disable-next-line eqeqeq
        this.loading = false
        console.log(this.loading)
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData() {
      exportDiceCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    addWeight(data) {
      data.push({
        'minBet': 1,
        'maxBet': 2,
        'pro': 2,
        'weight': [
          { 'v': 10, 'id': 1 },
          { 'v': 10, 'id': 2 },
          { 'v': 10, 'id': 3 },
          { 'v': 10, 'id': 4 },
          { 'v': 10, 'id': 5 },
          { 'v': 10, 'id': 6 }
        ]
      })
    },
    handlerShow(data) {
      let str = ''
      for (let i = 0; i < data.length; i++) {
        str += '(' + data[i].minBet + ',' + data[i].maxBet + ')-' + data[i].pro + ' '
        for (let j = 0; j < data[i].weight.length; j++) {
          str += '体力:' + (data[i].weight[j].id) + ',概率:' + data[i].weight[j].v + ';'
        }
        str += '<br/>'
      }
      return str
    }
  }
}
</script>

<style scoped>
</style>
